import {
  Alert,
  Box,
  Chip,
  Divider,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import {
  competenciaExibicao,
  dataExibicao,
  demonstrativos,
  moeda,
  pagamentos
} from "../../shared/apresentacaoEvento";
import { Campo } from "./Elementos";

export default function Demonstrativos({ dados = {} }) {
  const grupos = demonstrativos(dados);
  const pg = pagamentos(dados);
  if (!grupos.length && !pg.length)
    return (
      <Alert severity="info">
        Este evento não contém demonstrativos de remuneração ou pagamentos.
      </Alert>
    );
  return (
    <Stack spacing={3}>
      {grupos.length > 0 && (
        <Alert severity="info">
          Valores declarados ao eSocial. A natureza de cada rubrica depende do
          cadastro S-1010; sem essa classificação, a soma não representa o valor
          líquido do contracheque.
        </Alert>
      )}
      {grupos.map((g, i) => (
        <Paper
          variant="outlined"
          key={`${g.id}-${i}`}
          sx={{ overflow: "hidden", borderRadius: 2 }}
        >
          <Box
            sx={{
              p: 2,
              bgcolor: "primary.main",
              color: "primary.contrastText"
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              spacing={1}
            >
              <Typography variant="h6">Demonstrativo {g.id}</Typography>
              <Chip
                size="small"
                label={`${g.rubricas.length} rubricas`}
                sx={{ bgcolor: "rgba(255,255,255,.18)", color: "inherit" }}
              />
            </Stack>
          </Box>
          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid item xs={6}>
              <Campo
                label="Apuração"
                value={competenciaExibicao(dados.ideEvento?.perApur)}
              />
            </Grid>
            <Grid item xs={6}>
              <Campo
                label={g.beneficio ? "Benefício" : "Categoria"}
                value={g.beneficio || g.categoria}
              />
            </Grid>
          </Grid>
          <Divider />
          <TableContainer>
            <Table
              size="small"
              aria-label={`Rubricas do demonstrativo ${g.id}`}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Rubrica / tabela</TableCell>
                  <TableCell>Vínculo / referência</TableCell>
                  <TableCell align="right">Quantidade</TableCell>
                  <TableCell align="right">Fator</TableCell>
                  <TableCell align="right">Valor declarado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {g.rubricas.map((r, j) => (
                  <TableRow key={j} hover>
                    <TableCell>
                      <Typography fontWeight={600}>{r.codRubr}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        Tabela {r.ideTabRubr || "—"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {r.matricula || r.nrBeneficio || "—"}
                      <Typography variant="caption" display="block">
                        {competenciaExibicao(r.perRef)}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">{r.qtdRubr ?? "—"}</TableCell>
                    <TableCell align="right">{r.fatorRubr ?? "—"}</TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontVariantNumeric: "tabular-nums",
                        whiteSpace: "nowrap",
                        fontWeight: 600
                      }}
                    >
                      {moeda(r.vrRubr)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ))}
      {pg.length > 0 && (
        <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
          <Box
            sx={{
              p: 2,
              bgcolor: "primary.main",
              color: "primary.contrastText"
            }}
          >
            <Typography variant="h6">Pagamentos declarados</Typography>
            <Typography variant="body2">
              {pg.length} pagamentos · líquido informado no S-1210
            </Typography>
          </Box>
          <TableContainer>
            <Table size="small" aria-label="Pagamentos declarados">
              <TableHead>
                <TableRow>
                  <TableCell>Demonstrativo</TableCell>
                  <TableCell>Referência</TableCell>
                  <TableCell>Pagamento</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell align="right">Valor líquido</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pg.map((p, i) => (
                  <TableRow key={i}>
                    <TableCell>{p.ideDmDev || "—"}</TableCell>
                    <TableCell>{competenciaExibicao(p.perRef)}</TableCell>
                    <TableCell>
                      {dataExibicao(p.dtPgto).split(",")[0]}
                    </TableCell>
                    <TableCell>{p.tpPgto}</TableCell>
                    <TableCell
                      align="right"
                      sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
                    >
                      {moeda(p.vrLiq)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ p: 2, textAlign: "right", bgcolor: "grey.50" }}>
            <Typography variant="caption">
              Total líquido dos pagamentos deste evento
            </Typography>
            <Typography variant="h5" color="primary.main" fontWeight={700}>
              {moeda(
                pg.reduce(
                  (s, p) => s + Math.round(Number(p.vrLiq || 0) * 100),
                  0
                ) / 100
              )}
            </Typography>
          </Box>
        </Paper>
      )}
    </Stack>
  );
}
